import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, withHandlers } from 'recompose';
import { get } from 'lodash';
import { reduxForm } from 'redux-form';
import { saveAs } from 'file-saver';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import Address, { AddressField } from '@components/form/Address/Address';
import Date, { DateField } from '@components/form/Date/Date';
import { withNotifications } from '@components/hoc/withNotifications';
import { Input, InputField } from '@components/form';
import { fetch } from '@utils/utils';

const exportMovement = async (formData): Promise<boolean> => {
  try {
    const response = await fetch('/metropolis/api/hr/employee/location/export', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        streetId: formData.address.streetId,
        radius: formData.radius,
        from: formData.from,
        to: formData.to
      })
    });

    if (response.ok) {
      const blob = await response.blob();
      saveAs(blob, 'export');
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

const enhance = compose<any, any>(
  withNotifications({}),
  withHandlers({
    onSubmit: ({ handleLoader, addError }) => async formData => {
      handleLoader(true);

      if (!get(formData, 'address.streetId')) {
        addError('Nastala chyba při generování exportu: Ulice je povinné pole.');

        handleLoader(false);
        return;
      }

      const response = await exportMovement(formData);
      if (!response) {
        addError('Nastala chyba při generování exportu');
      }

      handleLoader(false);
    }
  }),
  reduxForm({
    form: 'export-officers-movement'
  })
);

const View = ({ closeItem, handleSubmit }) => (
  <div style={{ margin: '15px' }}>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <h4>Export</h4>
        </Row>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <AddressField component={Address} name={'address'} disabled={false} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <InputField component={Input} name={'radius'} label={'Radius'} type={'number'} />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <DateField component={Date} name={'from'} label={'Od'} />
              </Col>
              <Col md={6}>
                <DateField component={Date} name={'to'} label={'Do'} allowFuture={true} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
      <Button label={'Exportovat'} type="submit" primary={true} style={{ margin: '15px' }} />
      <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
    </form>
  </div>
);

export const ExportOfficersMovement = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/maps/dialogs/ExportMovementOfficers.tsx